import Link from 'next/link'
import { cn } from '@/utilities/ui'

import type { LinkButtonProps } from './types'
export type { LinkButtonProps } from './types'

export const LinkButtonBlock: React.FC<LinkButtonProps> = ({ url, text, className }) => {
    const context = text ? text : url
    return (
        <Link
            href={url}
            aria-label={`Link to ${context}`}
            rel='noopener noreferrer'
            className={cn(
                'bg-accent block rounded text-white w-full py-2 px-2 text-center transition ease-in-out duration-300 not-prose hover:brightness-90',
                className,
            )}
        >
            {context}
        </Link>
    )
}
